import { Injectable } from "@angular/core";
import {HttpEvent, HttpResponse} from "@angular/common/http";
import { LoggingService } from "./log.service";
import { Observable } from "rxjs";
import { SettingsService } from "../settings/settings.service";
import { RestfulService } from "./restful.service";
import { getEndPointWithParams } from "../../../assets/js/util.js";
import { Multiselect, RequestBody } from "../interfaces/admin.interface";
import * as ENDPOINT from "../../shared/constant/endPoint.js";
import { UtilsService } from "./utils.service";

@Injectable()
export class PortalService {
  private testAPI: boolean;

  private listAllPost: RequestBody = {
    paging: false,
    page: 0,
    rows: 0,
    orderBy: "",
    direction: "ASC",
    summary: true,
    filters: {},
  };

  constructor(
    private logger: LoggingService,
    private settings: SettingsService,
    private restful: RestfulService,
    private utils: UtilsService
  ) { }

  getMultiselectItems(multiselectType: Multiselect, param1: any = "", param2: any = ""): Observable<any> {
    let endPoint: string = '';
    this.testAPI = false;
    switch (multiselectType) {
      case Multiselect.USER:
        endPoint = ENDPOINT.admin_userList;
        const body = { ...this.listAllPost, filters: this.utils.getApiFilters(Multiselect.USER) };
        return this.post(endPoint, body); // Customer requires a post to create a custom multiselect
      case Multiselect.EMAIL:
        endPoint = ENDPOINT.multiselect_email;
        break;
      case Multiselect.ROLE_FILTER:
        endPoint = ENDPOINT.multiselect_filter;
        break;
      case Multiselect.ROLE_CREATION:
        endPoint = ENDPOINT.multiselect_creation;
        break;
      case Multiselect.HEADQUARTER:
        endPoint = ENDPOINT.multiselect_headquarter;
        break;
      case Multiselect.PROJECT_TYPE:
        endPoint = getEndPointWithParams(ENDPOINT.multiselect_projectType, param1);
        break;
      case Multiselect.PROJECT_CATEGORY:
        endPoint = getEndPointWithParams(ENDPOINT.multiselect_projectCategory, param1);
        break;
      case Multiselect.WORKFLOW:
        endPoint = getEndPointWithParams(ENDPOINT.multiselect_workflow, param1);
        break;
      case Multiselect.CUSTOMER_TYPE:
        endPoint = ENDPOINT.multiselect_customerType;
        break;
      case Multiselect.PROJECT_PHASES:
        endPoint = getEndPointWithParams(ENDPOINT.multiselect_project_phases, param1);
        break;
      case Multiselect.PROJECT_CHECKLISTS:
        endPoint = getEndPointWithParams(ENDPOINT.multiselect_project_chekclists, param1, param2);
        break;
      case Multiselect.PROJECT_ACTIVITIES:
        endPoint = getEndPointWithParams(ENDPOINT.multiselect_project_activities, param1, param2);
        break;
      case Multiselect.REMINDER_ASSOCIABLE_USERS:
        endPoint = getEndPointWithParams(ENDPOINT.multiselect_project_reminder_associable_users, param1);
        break;
      case Multiselect.PAYMENT:
        endPoint = ENDPOINT.payment_all;
        return this.post(endPoint, this.listAllPost); // Payment requires a post to create a custom multiselect
      case Multiselect.PAYMENT_CHANNEL:
        endPoint = ENDPOINT.multiselect_payment_channel;
        break;
      case Multiselect.COMPANY:
        endPoint = ENDPOINT.multiselect_company;
        break;
      case Multiselect.SUPPLIER:
        endPoint = getEndPointWithParams(ENDPOINT.multiselect_supplier, param1);
        break;
      case Multiselect.DISCOUT:
        endPoint = getEndPointWithParams(ENDPOINT.multiselect_discount, param1);
        break;
      case Multiselect.UM:
        endPoint = ENDPOINT.multiselect_um;
        break;
      case Multiselect.CREATION_SITE:
        endPoint = ENDPOINT.multiselect_creation_site;
        this.testAPI = true;
        break;
      case Multiselect.ACCOUNT_TYPE:
        endPoint = ENDPOINT.multiselect_account_type;
        break;
      case Multiselect.SEX:
        endPoint = ENDPOINT.multiselect_sex;
        break;
      case Multiselect.PRODUCT_TYPE:
        endPoint = ENDPOINT.multiselect_product_type;
        break;
      case Multiselect.PRODUCT_CATEGORY:
        endPoint = ENDPOINT.item_category_all;
        return this.post(endPoint, this.listAllPost); // Category requires a post to create a custom multiselect
      case Multiselect.PRODUCT_SUB_CATEGORY:
        endPoint = ENDPOINT.multiselect_product_sub_category;
        break;
      case Multiselect.PRODUCT_CATALOG:
        endPoint = ENDPOINT.multiselect_product_catalog;
        break;
      case Multiselect.PRODUCT_SIZE:
        endPoint = ENDPOINT.multiselect_product_size;
        break;
      case Multiselect.ORDER_CATALOG:
        endPoint = ENDPOINT.order_catalog_all;
        return this.post(endPoint, this.listAllPost); // Order catalog requires a post to create a custom multiselect
      case Multiselect.ORDER_JOB:
        endPoint = ENDPOINT.multiselect_order_job;
        this.testAPI = true;
        break;
      case Multiselect.ORDER_JOB_STATUS:
        endPoint = ENDPOINT.multiselect_order_job_status;
        this.testAPI = true;
        break;
      case Multiselect.ORDER_JOB_TYPE:
        endPoint = ENDPOINT.multiselect_order_job_type;
        this.testAPI = true;
        break;
    }
    return this.get(endPoint, this.testAPI);
  }

  getBackendVersion() {
    return this.get(ENDPOINT.backend_version, this.testAPI);
  }

  getElementListBySearchTerm(endpoint: string, searching: any, reqBody: RequestBody): Observable<any> {
    //let tempEndPoint = null;
    const tempEndPoint = searching != null ? getEndPointWithParams(endpoint, searching) :getEndPointWithParams(endpoint, '');
/*    if (searching != null) {
      tempEndPoint = getEndPointWithParams(endpoint, searching);
    } else {
      tempEndPoint = getEndPointWithParams(endpoint, '');
    }*/
    return this.post(tempEndPoint, reqBody);
  }

  post(endPoint: string, reqBody: any): Observable<any> {
    return Observable.create((observer) => {
      this.restful.post(endPoint, reqBody).subscribe((response) => {
        this.responseHandler(response, observer);
      });
    });
  }

  put(endPoint: string, reqBody: any): Observable<any> {
    return Observable.create((observer) => {
      this.restful.put(endPoint, reqBody).subscribe((response) => {
        this.responseHandler(response, observer);
      });
    });
  }

  delete(endPoint: string): Observable<any> {
    return Observable.create((observer) => {
      this.restful.delete(endPoint).subscribe((response) => {
        this.responseHandler(response, observer);
      });
    });
  }

  get(endPoint: string, testAPI: boolean): Observable<any> {
    return Observable.create((observer) => {
      this.restful.get(endPoint, testAPI).subscribe((response) => {
        this.responseHandler(response, observer);
      });
    });
  }

  responseHandler(response: HttpEvent<any>, observer: any): void {
    const outcome = response["outcome"];
    if (outcome.success === true) {
      this.logger.log("Service:", "SUCCESS", 200);
      observer.next(response);
    } else {
      this.logger.log("Service:", "FAILURE", 200);
      outcome.message = this.utils.manageErrorMsg(outcome);
      observer.error(outcome);
    }
  }
}
